import { NavLink } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const MenuItems = [
    {
        key: "home",
        path: "/app/home",
        label: "Нүүр",
    },
    {
        key: "person",
        path: "/app/human",
        label: "Иргэн хайх",
    },
    {
        key: "vehicle",
        path: "/app/vehicle",
        label: "Тээврийн хэрэгсэл",
    },
    {
        key: "company",
        path: "/app/company",
        label: "Хуулийн этгээд",
    },
    {
        key: "phone",
        path: "/app/phone",
        label: "Утасны дугаар",
    },
    {
        key: "callCheck",
        path: "/app/callCheck",
        label: "Сонгууль AI хууль шалгах",
    },
    // {
    //     key: "foreign",
    //     path: "/app/foreign",
    //     label: "Гадаадын иргэн",
    // },
    {
        key: "login",
        path: "/login",
        label: "Системээс гарах",
    }
]

const Menu = ({ pages }) => {
    // console.log({ pages })
    return <div className="flex flex-col">
        {
            MenuItems.map(({ key, path, label }) => {
                if (!pages[key] && !["home", "login"].includes(key)) return null

                return <NavLink key={key} to={path} className={({ isActive }) => `w-full flex p-2 border-b ${isActive ? "bg-primary-900 text-white" : "bg-white"}`}>{label}</NavLink>
            })}
    </div>
}

export default Menu